/**
 * The portal session read, in one shape for every partner, and the name the
 * shell shows ("🦉 Owl"). Pure, so it is tested directly.
 */
import type { FlowPartnerKind, PartnerSession, PartnerSessionDto } from "../types.ts";

function idOf(partner: FlowPartnerKind, dto: PartnerSessionDto): string {
  const raw =
    partner === "printer"
      ? (dto as { printerId?: unknown }).printerId
      : partner === "fc"
        ? (dto as { fcId?: unknown }).fcId
        : (dto as { warehouseId?: unknown }).warehouseId;
  return raw == null ? "" : String(raw);
}

export function toPartnerSession(partner: FlowPartnerKind, dto: PartnerSessionDto): PartnerSession {
  return {
    partner,
    partnerId: idOf(partner, dto),
    nickname: dto.nickname?.trim() ?? "",
    icon: dto.icon?.trim() || null,
  };
}

/** "🦉 Owl", or just "Central Ohio FC" when the partner has no emoji. */
export function partnerDisplayName(session: Pick<PartnerSession, "nickname" | "icon">): string {
  return [session.icon, session.nickname].filter(Boolean).join(" ");
}
